import { Col, Flex, Row } from 'antd';
import HeaderCard from 'components/HeaderCard';
import RBCountryFilter from 'components/UniversalFilters/RBCountryFilter';
import SeasonIndexFilter from 'components/UniversalFilters/SeasonIndexFilter';
import i18n from 'utils/i18n';

import AgronomistDueWidget from './components/AgronomistDueWidget';
import DueStatusWidget from './components/DueStatusWidget';
import EHDStatusWidget from './components/EHDStatusWidget';

import useCountryAndSeasonIndexFilter from 'hooks/useCountryAndSeasonIndexFilter';
import useCollectionOverviewLink from './hooks/useCollectionOverviewLink';
import useDueAgronomistQuery from './hooks/useDueAgronomistQuery';
import useDueSummaryQuery from './hooks/useDueSummaryQuery';
import useEHDChangeQuery from './hooks/useEHDChangeQuery';

import './styles.scss';

const { t } = i18n.i18n;

const CollectionDashboard = () => {
  const {
    currentCountry: country,
    currentSeasonIdx: seasonIndex,
    setCurrentCountry: setCountry,
    setCurrentSeasonIdx: setSeasonIndex,
  } = useCountryAndSeasonIndexFilter();

  const link = useCollectionOverviewLink();

  const { data: summaryData } = useDueSummaryQuery({ country });
  const { data: agronomistData } = useDueAgronomistQuery({
    country,
  });
  const { data: ehdChangeData } = useEHDChangeQuery({
    country,
    seasonId: seasonIndex!,
  });

  return (
    <>
      <HeaderCard
        headerLabel={t('collectionOverview.header')}
        headerInfo={t('collectionOverview.subHeader')}
        filters={
          <Flex gap={20} align="center" wrap="wrap">
            <RBCountryFilter selectedCountry={country} onChange={setCountry} />
            <SeasonIndexFilter
              country={country}
              seasonIndex={seasonIndex!}
              setSeasonIndex={setSeasonIndex}
            />
          </Flex>
        }
      />
      <Row className="collections-dashboard" gutter={[12, 20]}>
        <Col span={24} md={8}>
          <DueStatusWidget data={summaryData?.data} />
        </Col>
        <Col span={24} md={16}>
          <AgronomistDueWidget data={agronomistData?.data} />
        </Col>
        <Col span={24}>
          <EHDStatusWidget data={ehdChangeData?.data} />
        </Col>
      </Row>
      <iframe src={link} width="100%" height="700" />
    </>
  );
};

export default CollectionDashboard;
